import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { ethers } from "ethers";
import Navigation from "./Navigation";
import Hero from "./Hero";
import Create from "./Create";
import DisplayNFTs from "./DisplayNFTs";

import NFT_ABI from "../abis/NFT.json";
import config from "../config.json";

function App() {
  const [provider, setProvider] = useState(null);
  const [nft, setNFT] = useState(null);
  const THETANETWORKID = 365;
  const [chainId, setChainId] = useState(null);
  const [account, setAccount] = useState(null);
  const [balance, setBalance] = useState(0);
  const [wallet, setWallet] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  async function checkingNetwork() {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    // capturamos la red
    const networkFromMetamask = await provider.getNetwork();
    console.log(`networkFromMetamask`, networkFromMetamask);
    return networkFromMetamask.chainId;
  }

  const loadBlockchainData = async () => {
    // Initiate provider
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    setProvider(provider);

    const { chainId } = await provider.getNetwork();
    setChainId(chainId);

    // Reload page when network changes
    window.ethereum.on("chainChanged", async () => {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      console.log(`accounts[0]`, accounts[0]);
      setAccount(accounts[0]);
      window.location.reload();
    });

    // Fetch current account from Metamask when changed
    window.ethereum.on("accountsChanged", async () => {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const account = ethers.utils.getAddress(accounts[0]);
      setAccount(account);
    });
    // Initiate contract
    const nft = new ethers.Contract(
      config[chainId].nft.address,
      NFT_ABI,
      provider
    );
    setNFT(nft);

    fetchAccountInfo();

    setIsLoading(false);
  };

  const fetchAccountInfo = async () => {
    if (account) {
      const balanceTFuel = await provider.getBalance(account);
      const readBalance = ethers.utils.formatEther(balanceTFuel);
      console.log("balance: ", readBalance);
      if (readBalance < 90) {
        window.alert("You need 90 Tfuel of test to mint");
        window.location.reload();
        return;
      } else {
        setWallet(await nft.walletOfOwner(account));
        setBalance(await nft.balanceOf(account));
      }
    }
  };

  useEffect(() => {
    async function checkNetwork() {
      const id = await checkingNetwork();
      console.log(`Network id`, id);
      if (THETANETWORKID === id) {
        loadBlockchainData();
      } else {
        forceChangeChain();
      }
    }

    checkNetwork();
  }, [isLoading]);

  // initial load of wallet for DisplayNFTs
  useEffect(() => {
    console.log(`account`, account);
    fetchAccountInfo();
  }, [account]);

  async function forceChangeChain() {
    let res = await changeNetwork();
    if (res) {
      loadBlockchainData();
    }
  }

  async function changeNetwork() {
    // cambiar de cadena
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x16D" }], // Ensure the selected network is bsc testnet // 0x38 bsc mainnet
      });
      return true;
    } catch (e) {
      if (e.code === 4001) {
        // setError("User rejected switching chains.");
        window.location.reload();
      }
    }
  }

  return (
    <Container>
      <Navigation account={account} setAccount={setAccount} chainId={chainId} />

      {account ? (
        <>
          <Create
            nft={nft}
            provider={provider}
            account={account}
            fetchAccountInfo={fetchAccountInfo}
          />

          <DisplayNFTs
            nft={nft}
            account={account}
            wallet={wallet}
            balance={balance}
          />
        </>
      ) : (
        <Hero setAccount={setAccount} />
      )}
    </Container>
  );
}

export default App;
